var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center",class:{'w-full h-screen items-center': _vm.fullscreen}},[_c('div',{staticClass:"loader ease-linear rounded-full border-gray-200",class:("w-" + _vm.size + " h-" + _vm.size)})])}
var staticRenderFns = []

export { render, staticRenderFns }